<button
  [type]="type"
  [ngClass]="cssClasses"
  [attr.disabled]="(disabled || loading) ? true : null"
  [attr.title]="tooltip || null"
  [attr.aria-label]="tooltip || null"
  (click)="handleClick($event)">

  <!-- Loading spinner -->
  <span *ngIf="loading" class="spinner-border spinner-border-sm is-btn__spinner" role="status" aria-hidden="true"></span>

  <!-- Icon left -->
  <i *ngIf="icon && !loading && iconPosition === 'left'" [class]="'bx ' + icon + ' is-btn__icon'"></i>

  <!-- Content -->
  <span class="is-btn__content" *ngIf="!isIconOnly">
    <ng-content></ng-content>
  </span>

  <!-- Icon right -->
  <i *ngIf="icon && !loading && iconPosition === 'right'" [class]="'bx ' + icon + ' is-btn__icon'"></i>
</button>
